import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.15, as: Tag = "h1" }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag className={className} data-testid="masked-lines">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold ${
      dark ? "text-pine-300" : "text-pine-500"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-pine-300" : "bg-pine-500"}`} />
    {children}
  </span>
);
